export default __webpack_public_path__ + "static/media/mx_ad_banner_mobile.79d089d8.jpg";